<template>
  <div class="edit-studio-container">
    <main class="tab-content">
      <h2 class="item text-secondary">Newsletter content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec">
          <label>Title:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.newsletter_title" />
        </div>
        <div class="field-sec">
          <label>Name placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.name_placeholder" />
        </div>
        <div class="field-sec">
          <label>Email placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.email_placeholder" />
        </div>
        <div class="field-sec">
          <label>Button text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.btn_text" />
        </div>
        <div class="field-sec">
          <label>ID:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.news_letter_id" />
        </div>
        <div class="field-sec">
          <label>zcld:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.zcld" />
        </div>
        <div class="field-sec">
          <label>cmpZuid:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.cmpZuid" />
        </div>
        <div class="field-sec">
          <label>Error message:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.error_msg" />
        </div>
      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <br>
      <h3 class="text-secondary">Example:</h3>
      The example is for testing the content but may not be functional:
      <br>
      <div class="newsletter-form" data-type="signupform" id="">
        <div id="customForm">
          <div class="quick_form_5_css stronger not-fixed" name="SIGNUP_BODY">
            <div>
              <span id="SIGNUP_HEADING" class="signup-heading">{{ fit20.blockToEdit.newsletter_title }}</span>
              <form method="POST" id="zcampaignOptinForm" action="" target="_zcSignup">
                <div id="newsletter_errorMsgDiv" class="error-msg" style="display: none"></div>
                <div class="newsletter-fields-div">
                  <div class="newsletter-input-div">
                    <!-- <label><?=t("First Name");?></label> -->
                    <input type="text" class="input" changeitem="SIGNUP_FORM_FIELD" name="FIRSTNAME" id="FIRSTNAME"
                      :placeholder="fit20.blockToEdit.name_placeholder" required />
                  </div>
                  <div class="newsletter-input-div newsletter-input-div2">
                    <!-- <label><?=t("Email");?></label> -->
                    <input type="email" class="input" changeitem="SIGNUP_FORM_FIELD" name="CONTACT_EMAIL"
                      id="EMBED_FORM_EMAIL_LABEL" :placeholder="fit20.blockToEdit.email_placeholder" required />
                  </div>
                </div>
                <div>
                  <p id="newsletter_recaptcha"> This site is protected by reCAPTCHA and the Google Privacy Policy and
                    Terms of Service apply.</p>
                  <div class="flex">
                    <div class="newsletter-btn-div">
                      <input type="button" class="newsletter-form-btn" name="SIGNUP_SUBMIT_BUTTON" id="zcWebOptin"
                        :value="fit20.blockToEdit.btn_text" />
                    </div>
                  </div>
                </div>

                <!-- Do not edit the below Zoho Campaigns hidden tags -->
                <input type="hidden" id="fieldBorder" value="" />
                <input type="hidden" id="submitType" name="submitType" value="optinCustomView" />
                <input type="hidden" id="emailReportId" name="emailReportId" value="" />
                <input type="hidden" id="formType" name="formType" value="QuickForm" />
                <input type="hidden" name="zx" id="cmpZuid" value="" />
                <input type="hidden" name="zcvers" value="2.0" />
                <input type="hidden" name="oldListIds" id="allCheckedListIds" value="" />
                <input type="hidden" id="mode" name="mode" value="OptinCreateView" />
                <input type="hidden" id="zcld" name="zcld" value="" />
                <input type="hidden" id="document_domain" value="" />
                <input type="hidden" id="zc_Url" value="blgy.maillist-manage.eu" />
                <input type="hidden" id="new_optin_response_in" value="0" />
                <input type="hidden" id="duplicate_optin_response_in" value="0" />
                <input type="hidden" name="zc_trackCode" id="zc_trackCode" value="ZCFORMVIEW" onload="" />
                <input type="hidden" id="zc_formIx" name="zc_formIx" value="" />
                <!-- End of the Zoho Campaigns hidden tags -->
              </form>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="btn-container">
        <span id="cancelUser3" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser3" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>
  </div>
</template>

<script>

export default {
  name: 'NewsLetter',
  props: ["fit20", "saveBlock", "cancelEditing"],

};
</script>

<style scoped>
.newsletter-btn-div {
  margin: 0 auto;
}

.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.tab-content {
  padding-top: 15px;
}

.tab-content h2 {
  margin-left: 10px;
}

.img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-container div {
  width: calc(100% / 2 - 30px);
}

.form-container label {
  display: block;
}

.studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.users-col {
  width: calc(100%);
}

.studio-machines {
  width: 100%;
}

.ex-member-container {
  margin-top: 10px;
}

.ex-member-flex {
  width: 100% !important;
}

.ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.ex-member-container img {
  margin-bottom: 7px;

}

.measure-div {
  position: relative;
}

.kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}

/* example css */
.newsletter-form {
  background: url('https://www.fit20.com/files/images/Global/Global Grids/FIT02680 - Headers website iconen patronen DNA - fit20 franchise2.png');
  padding: 40px 0 !important;
}

#customForm {
  max-width: 1500px !important;
  margin: auto !important;
  text-align: center !important;
}

body div.quick_form_5_css.stronger {
  background-color: white !important;
  width: 60% !important;
  margin: auto !important;
  padding: 50px 10px !important;
  border-radius: 10px !important;
  color: #616365 !important;
}

.signup-heading {
  font-family: 'VAG Rounded Std light', Verdana, Tahoma, sans-serif !important;
  font-size: 46px !important;
}

.newsletter-fields-div {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

.newsletter-input-div {
  display: inline !important;
  border: solid 1px #5e7fb133 !important;
  padding: 5px 10px !important;
  font-size: 20px !important;
  border-radius: 5px !important;
}

.newsletter-input-div2 {
  margin-left: 10px !important;
}

.newsletter-input-div input {
  border: none !important;
  outline: none !important;
  width: 40% !important;
  padding: 0px !important;
  font-size: 15px !important;
  max-width: 230px !important;
}

#newsletter_recaptcha {
  font-size: 9px !important;
}

.newsletter-btn-div input {
  cursor: pointer !important;
  color: white !important;
  background-color: #fc802d !important;
  border: solid 1px #fc802d !important;
  border-radius: 20px !important;
  padding: 5px 25px !important;
  margin-top: 10px;
  transition: color 0.5s, background-color 0.5s !important;
  width: fit-content !important;
}

.newsletter-btn-div input:hover {
  color: #fc802d !important;
  background-color: #ffffff !important;
  /* border: solid 1px #fc802d !important; */
}

@media only screen and (max-width: 850px) {
  .quick_form_5_css {
    width: 60% !important;
  }

  .signup-heading {
    font-size: 30px !important;
  }
}

@media only screen and (max-width: 600px) {
  .signup-heading {
    font-size: 25px !important;
    line-height: 30px !important;
  }

  body div.quick_form_5_css.stronger {
    width: 90% !important;
  }

  .newsletter-fields-div {
    display: inline-grid !important;
    width: 80%;
  }

  .newsletter-input-div2 {
    margin: 10px 0px 0px 0px !important;
  }

  .newsletter-fields-div input {
    width: 100% !important;
  }

  #newsletter_recaptcha {
    font-size: 9px !important;
  }

  .newsletter-input-div input {
    max-width: 500px !important;
  }
}
</style>
